module.exports = __webpack_public_path__ + "img/location-encart.c24b931c.svg";